import { useState } from 'react';
import { Link }from "react-router"
import CreditosDialog from 'src/components/CreditosDialog';

import 'src/css/Footer.scss';

export default function Header() {

    const [openDialog, setOpenDialog] = useState(false);

    const hCloseDialog = () => {
        setOpenDialog(false);
    }

    return (
        <>
            <div className="papime">
                Trabajo realizado con el apoyo del Programa UNAM-DGAPA-PAPIME PE 102322
            </div>
            <footer id="footer">
                <div className="leyenda">
                    Hecho en México. Universidad Nacional Autónoma de México (UNAM). Todos los derechos
                    reservados 2024. Esta página puede ser reproducida con fines no lucrativos, siempre
                    y cuando se cite la fuente completa y su dirección electrónica, y no se mutile; de
                    otra forma requiere permiso previo por escrito de la institución.
                </div>
                <div className="enlaces">
                    {/* <Link href="acercade"> <span>Acerca de</span> </Link> */}
                    {/* <Link href="contacto"> <span>Contacto</span> </Link> */}
                    <button className='lnk' onClick={() => setOpenDialog(true)}>Créditos</button>
                </div>
                <CreditosDialog {...{openDialog, hCloseDialog}} />
            </footer>
        </>

    )
}


